import PropTypes from "prop-types";

// Components
import InputFormExtension from "@/Layouts/components/InputComponents/InputFormExtension";
import SimpleTextField from "@/Layouts/components/InputComponents/SimpleTextField";
import SmartSelector from "@/Layouts/components/InputComponents/SmartSelector";

// MUI
import { Grid, Stack } from "@mui/material";
import { useState } from "react";

const mapSelectedProduct = (product = "") => (!product ? null : { label: product });

export default function TieredItem({ ...props }) {
	const {
		addSeparator = false,
		width = 6,
		error = false,
		related = false,
		readOnly = false,
		input = {
			input: "Percent",
			value: 0,
			product: "",
		},
		inputData = [
			{
				type: "Percent",
				min: 0,
				max: 100,
				decimalsEditable: true,
				decimals: 2,
			},
			{
				type: "Dollar",
				min: 0,
				max: 10000,
				decimalsEditable: false,
				decimals: 2,
			},
		],
		products = [],
		selectOptions = {
			text: "",
			useLabel: false,
			related: false,
			blink: false,
		},
		actionsCallbacks = {
			onClickInput: () => {},
			onFocusOut: () => {},
			onChangeType: () => {},
			onActionUpdate: () => {},
		},
		selectionCallbacks = {
			onSelect: () => {},
			onSelectOpen: () => {},
			onSelectClose: () => {},
		},
		containerProps = {
			direction: "row",
			spacing: 2,
			alignItems: "center",
			justifyContent: "space-between",
			sx: { position: "relative" },
		},
		inputContainerProps = {
			spacing: 1,
			alignItems: "center",
			justifyContent: "center",
			sx: { width: "48%", maxWidth: "90px" },
		},
		selectContainerProps = {
			spacing: 1,
			alignItems: "flex-start",
			justifyContent: "center",
			sx: { width: "54%", maxWidth: "120px", marginLeft: "5px !important" },
		},
	} = props;

	const [focusIn, setFocusIn] = useState(false);

	return (
		<Grid item xs={width} className={"tiered-item"}>
			<Stack {...containerProps}>
				<Stack {...inputContainerProps}>
					<InputFormExtension
						readOnly={readOnly}
						disabled={readOnly}
						data={inputData}
						value={input.value || 0}
						defaultType={input.input || "Percent"}
						error={error}
						related={related && !error}
						isEditingMode={focusIn}
						onClickInput={() => {
							setFocusIn(true);
							actionsCallbacks?.onClickInput?.();
						}}
						onChangeType={(value, input) => {
							actionsCallbacks?.onChangeType?.(value, input);
						}}
						onActionUpdate={(value, input) => {
							actionsCallbacks?.onActionUpdate?.(value, input);
						}}
						onFocusOut={(value, input) => {
							setFocusIn(false);
							actionsCallbacks?.onFocusOut?.(value, input);
						}}
					/>
				</Stack>

				{addSeparator && <div className="icon-divider">+</div>}

				<Stack {...selectContainerProps}>
					{selectOptions?.useLabel ? (
						<SimpleTextField {...selectOptions} readOnly={readOnly} />
					) : (
						<SmartSelector
							showBy={"label"}
							selectBy={"label"}
							options={products}
							selected={mapSelectedProduct(input?.product)}
							disabled={readOnly}
							listBoxProps={{
								sx: { maxHeight: "185px" },
							}}
							popperProps={{
								sx: { minWidth: "140px", maxWidth: "210px" },
							}}
							onCloseAction={() => selectionCallbacks?.onSelectClose?.(input?.label || "")}
							onChangeAction={(value) => {
								selectionCallbacks?.onSelect?.(value?.label);
							}}
							onOpenAction={() => {
								selectionCallbacks?.onSelectOpen?.();
							}}
						/>
					)}
				</Stack>
			</Stack>
		</Grid>
	);
}

TieredItem.propTypes = {
	addSeparator: PropTypes.bool,
	width: PropTypes.number,
	error: PropTypes.bool,
	related: PropTypes.bool,
	readOnly: PropTypes.bool,
	input: PropTypes.object,
	inputData: PropTypes.array,
	products: PropTypes.array,
	selectOptions: PropTypes.object,
	actionsCallbacks: PropTypes.object,
	selectionCallbacks: PropTypes.object,
	containerProps: PropTypes.object,
	inputContainerProps: PropTypes.object,
	selectContainerProps: PropTypes.object,
};
